"use strict";
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import {
   FeatureFlagContext,
   FeatureFlagProvider,
   ToastContextProvider,
   AuthContextProvider,
} from "./utilities/contexts";
import localStorageMigrate from "./utilities/localStorage/LocalStorageConfig";
import ErrorPage from "./pages/utility/ErrorPage/ErrorPage";
import ErrorBoundary from "./utilities/ErrorBoundary";
import ECLUtility from "./pages/utility/ECLUtility/ECLUtility";
import AuthRouter from "./routers/AuthRouter";
import "./GlobalStyleSheet.css";
import { FAContextProvider } from "./utilities/contexts/FontAwesomeContext";

localStorageMigrate(); //Migrate the localStorage if necessary on site load

const App = () => {
   //Service Worker registration
   useEffect(() => {
      if ("serviceWorker" in navigator) {
         window.addEventListener("load", () => {
            navigator.serviceWorker
               .register("/sourceone/static/sw.js", {
                  scope: "/sourceone/static/",
               })
               .then((registration) => {
                  console.log("SW registration succeeded: ", registration); //eslint-disable-line
                  navigator.serviceWorker.ready.then(function (registration) {
                     console.log("SW is active: ", registration.active); //eslint-disable-line
                  });
               })
               .catch((registrationError) => {
                  console.error("SW registration failed: ", registrationError); //eslint-disable-line
               });
         });
      }
   }, []);

   return (
      <div
         id="thematic-div"
         data-theme={
            localStorage.getItem("userTheme") === "Dark" ? "Dark" : "Light"
         }
      >
         <div className="universal-height-width-container">
            <ErrorBoundary
               fallback={
                  <ECLUtility>
                     <ErrorPage />
                  </ECLUtility>
               }
            >
               <FAContextProvider>
                  <FeatureFlagProvider>
                     <FeatureFlagContext.Consumer>
                        {() => {
                           return (
                              <ToastContextProvider>
                                 <BrowserRouter>
                                    <AuthContextProvider>
                                       <AuthRouter />
                                    </AuthContextProvider>
                                 </BrowserRouter>
                              </ToastContextProvider>
                           );
                        }}
                     </FeatureFlagContext.Consumer>
                  </FeatureFlagProvider>
               </FAContextProvider>
            </ErrorBoundary>
         </div>
      </div>
   );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
